module.exports = __webpack_public_path__ + "img/sfks-3.44e163a2.png";